import React from 'react'
import TextField from '@mui/material/TextField';
import { FormControl, FormHelperText, FormLabel, Grid } from '@mui/material';
import EditorComponent from './EditorComponent';

const FormEditToolTip = ({setContent,editTooltipInfo,setEditTooltipInfo,content}) => {

    const changeHandler = (e) => {
        setEditTooltipInfo((prevState) =>
        ({...prevState, [e.target.name]: e.target.value })); 
    };

    return (
    <Grid container >
        <FormControl fullWidth sx={{ m: 1, width: '90ch' }}>
        <FormLabel id="file-select-label">Event ID</FormLabel>
        <TextField
            disabled
            id="eventId"
            fullWidth
            name="event_id"
            value={editTooltipInfo.event_id} 
        />
        </FormControl>
        <FormControl fullWidth sx={{ m: 1, width: '90ch' }}>
            <FormLabel id="file-select-label">Description</FormLabel> 
            <TextField
                id="eventName"
                name="event_name"
                value={editTooltipInfo.event_name}
                onChange={changeHandler}
                error={editTooltipInfo.event_name === ""}
                helperText={editTooltipInfo.event_name === "" ? "Required Field!" : " "} 
            />
        </FormControl> 
        <FormControl fullWidth sx={{ m: 1, width: '90ch' }}>
            <FormLabel id="file-select-label">Description Content</FormLabel> 
            <EditorComponent setContent={setContent} content={editTooltipInfo.description} isPopup={false} event_id={editTooltipInfo.event_id}
            />
            { editTooltipInfo.description === "" ? <FormHelperText sx={{color:'#d32f2f'}} id="component-error-text">Required Field!</FormHelperText> : <></> }
        </FormControl>
    </Grid>
  )
}

export default FormEditToolTip